var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedyStudentSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_109_9460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_109_9460",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_9460",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_9460",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEJ0lEQVR4nO3cW6gWRQAH8FErTZTKogsVlARd0bKih3rooZeCgoiIIoouhD1EL5UPFVoPZjciMiKIokQIH6LbW9CF7hDZQ2VpahBlGRZqebrpLwZHOsQ5n9+357vM7s4PDhzOZXb3/+3OzM7MbghFURRFURRFURRFURRFFjAXN+EVbMIYtmEtHsKCLspYiIfxWfrfsVRWLPNGzAlthWlYjJ90tgcv4sgJyjgKa9LfdPIjbgltg1lYvZ9wJgrrzHFlnJV+1otVmBladCavVs0vOAfnpu+rWBXaALeamh/S11Q0uxrBnAqX+yDEdmFuaCrcLB83hKbCq/LxcmgqbJaPjaGpsEs+doWmwm/ysSM0lbyqjk2hqewde8jFS6GpcJd83BGaCifJx/zQZHh31AnjrdB0uHzUKeOy0JLRu7dHGHK8oqaFNsAZ+HsEIcdtLgxtgidHEPRjoaVzheuGGPKXrZ07xMnYPoSQd+K00Ga4aghBXzvq48wClg0w5GWjPr6s4NEBhLxy1MeVHUzHC30M+fnW9Jd7hRl4pg8hx/UbB/S8A21i753jVKqRlfHqGPVx1Abu6WKp13jxb+8e9X7XEq7A712EHBc1XhPqJNZtuARP46s0z7cdn+MpXDjMSxOL8F2HkOPvFoW6wOlYgS1dnEHfYAkOHdK+HYOPJ9iPT3F8yB2OS4HFs7WKX/EIThjCvh6ctrU1fcXvZ4VcpR2+Eq/1cahydyrvotBm6WbgglTvxgGWQVobV2vGDzS0Rap34zjCt0azYnMFjg1NJw9/pscfzgtNJT+f4LrG3R7L16bU25kXmkD+dqYG+tRQZ+pjN97ApbUc2lRPX+N2zA51od62pnq87/1xnIgHsCH1iuKQwn2Vt6UZ3uxH2Omm7eJ0Bxurqol8UGlbmmPJFAKeF5foprN2MJO5muOLCscen7B9tsJzMxvaHPSuHp4xv36SIdVujbU56PX7Oc75eBA/92Fb69oc9NJJGrc4E/R6h8atit7nHTXD++N7Ajgcd8YHMgewrXdwUJuC/if1cZfuCzm9OuK5NBHbb7HM5ZVCrnnQw7InDeFO7cGhoe1uPX2E86cUcAm6o/VpzrR/g1d6swNPpLnF+AKT2WlNxf34Xv3Frt9tOLBvAfcY9MY0eHNYh3KmxxnuNE7QyzKtHMRBo8cHugZlPzvwXrqEZlR4+nVFGl1rfkPXZSj/90dag7ygD2XPTB9UHLDPzYd9a+i6DGOfLWnZwRED2s4p6Syv+oq0fBu6LgOIXZirB9IATP5I2+L06spmNHS5w9lp4rWbZbf5NnR1gUPSErGqCylH29DVkb199BjQX7Vp6OoMR6e+++bsG7om8N+N0Jo0YjeRbelDacdbcgctzZIsT2fuWHqs495Yxw9840VRFEVRFEVRFEVRFKF9/gUe6Oh30lPDPwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedyStudentSupport);
export default __webpack_public_path__ + "static/media/Needy Student Support.10a0f92b0104cfb298f4e286375b08f4.svg";
export { ForwardRef as ReactComponent };